module.exports = __webpack_public_path__ + "4a1429efd56ba3f4e4fcaed81c069591.MP3";